export const BASE_URL = 'https://quotes.resolve.co.uk'
export const BASE_API_URL = 'https://resolve-quotes-be.azurewebsites.net'
export const PAGE_SIZE = 10